import type { Position } from '@/lib/types'

/** Ce qui est ouvert sur une paire, résumé pour les sélecteurs. */
export interface HeldSymbol {
  /** Nombre de positions ouvertes sur la paire. */
  count: number
  /** Résultat latent cumulé, en VUE STRATÉGIE — celle de toute l'application. */
  profit: number
  currency: string
}

/**
 * Positions ouvertes, regroupées par paire.
 *
 * Sert aux deux endroits où l'on choisit une paire : la barre rapide et le
 * sélecteur complet. Choisir une paire sans savoir qu'on y est déjà engagé,
 * c'est risquer d'en ouvrir une seconde sans l'avoir voulu — et de doubler
 * l'exposition sans jamais l'avoir décidé.
 */
export function heldBySymbol(positions: Position[]): Record<string, HeldSymbol> {
  const held: Record<string, HeldSymbol> = {}
  for (const position of positions) {
    const current = held[position.symbol]
    const profit = Number(position.entry_profit ?? 0)
    held[position.symbol] = {
      count: (current?.count ?? 0) + 1,
      profit: (current?.profit ?? 0) + (Number.isFinite(profit) ? profit : 0),
      currency: position.account_currency,
    }
  }
  return held
}

/** Montant signé, tel qu'il s'affiche à côté d'une paire. */
export function formatHeld(held: HeldSymbol): string {
  const signe = held.profit >= 0 ? '+' : ''
  return `${signe}${held.profit.toFixed(2)} ${held.currency}`
}

/**
 * Ce que le compte perdrait si TOUTES mes cibles étaient atteintes.
 *
 * L'ordre partant inversé, ma cible est le stop du courtier : ce total se lit
 * donc sur le risque réel de chaque position. `null` dès qu'une position n'est
 * pas chiffrable — un total partiel se lirait comme un total, et rassurerait
 * à tort.
 */
export function targetsEngaged(positions: Position[]): number | null {
  let total = 0
  for (const position of positions) {
    if (position.risk_amount === null) return null
    total += Number(position.risk_amount)
  }
  return total
}
